<template>
  <v-container id="modelos-caderno-servicos-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <modelos-cadernos-servicos-data-table
          :items="items"
          :loadingItems="loadingItems"
          @rechargeTable="getModelosCadernosServicos()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ModelosCadernosServicos from '@/services/parametrosComCa/ModelosCadernosServicosService';
  import dayjs from 'dayjs';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    name: 'IndexModelosCadernosServicos',

    components: {
      ModelosCadernosServicosDataTable: () =>
        import('@/components/parametrosComCa/modelosCadernosServicos/ModelosCadernosServicosDataTable.vue')
    },

    mixins: [pusherMixins],

    data() {
      return {
        items: [],
        loadingItems: false
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    mounted() {
      this.subscribe();
      this.getModelosCadernosServicos();
    },

    methods: {
      getModelosCadernosServicos() {
        this.loadingItems = true;

        ModelosCadernosServicos.getModelos()
          .then(({ data }) => {
            this.items = data.modelos.map((modelo) => ({
              id: modelo.id,
              nome: modelo.nome,
              usuario: modelo.usuario.nome,
              executado: modelo.data_execucao ? dayjs(modelo.data_execucao).format('DD/MM/YYYY HH:mm') : '-',
              status: modelo.status,
              dataInicial: modelo.data_inicial ? dayjs(modelo.data_inicial).format('DD/MM/YYYY') : '-',
              dataFinal: modelo.data_final ? dayjs(modelo.data_final).format('DD/MM/YYYY') : '-',
              obras: JSON.parse(modelo.obras),
              tipologias: JSON.parse(modelo.tipologias),
              obraNaoPertence: modelo.obra_nao_pertence,
              tipologiaNaoPertence: modelo.tipologia_nao_pertence
            }));
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar os Modelos de Cadernos de Serviços.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.loadingItems = false));
      },

      subscribe() {
        this.pusherChannel.bind('refreshModelosCadernosServicos', () => {
          this.getModelosCadernosServicos();
        });
      }
    }
  };
</script>


<style>
  
</style>